/**
 * Token/turn styling shared between the live `Renderer` (token stream during
 * recording) and saved meeting detail views through `TranscriptTokenStream`.
 *
 * Keeping these constants in one module guarantees the bilingual detail view
 * renders pixel-identically to the live Input/Output panes.
 */

export interface TranscriptStreamStyles {
  languagePillClass: string
  finalTokenClass: string
  draftTokenClass: string
}

export const sourceStyles: TranscriptStreamStyles = {
  languagePillClass:
    'bg-[var(--bg-tertiary)] text-[var(--text-secondary)] border border-[var(--border-color)] shadow-sm',
  finalTokenClass: 'text-[15px] text-[var(--text-primary)] leading-[1.65] tracking-tight',
  draftTokenClass:
    'text-[15px] text-[var(--text-tertiary)] dark:text-[var(--text-secondary)] leading-[1.65] tracking-tight',
}

export const translationDevStyles: TranscriptStreamStyles = {
  languagePillClass: 'bg-[var(--accent)] text-white border border-[var(--accent)] shadow-sm',
  finalTokenClass:
    'text-base sm:text-[15px] font-medium text-[var(--accent)] leading-[1.65] tracking-tight',
  draftTokenClass:
    'text-base sm:text-[15px] text-[var(--text-tertiary)] dark:text-[var(--text-secondary)] leading-[1.65] tracking-tight transition-colors duration-150',
}
